import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { RootState } from 'src/redux/createRootReducer'

export const SET_ORG_EXPENSE_REPORT_DATE_UPDATE_CONFIRMED =
  'data/organizations/SET_ORG_EXPENSE_REPORT_DATE_UPDATE_CONFIRMED'

export interface SetOrgExpenseReportDateUpdateConfirmedAction {
  type: typeof SET_ORG_EXPENSE_REPORT_DATE_UPDATE_CONFIRMED
  payload: boolean
}

export const createSetOrgExpenseReportDateUpdateConfirmed =
  (
    confirmed: boolean,
  ): ThunkAction<
    void,
    RootState,
    void,
    SetOrgExpenseReportDateUpdateConfirmedAction
  > =>
  (
    dispatch: ThunkDispatch<
      RootState,
      void,
      SetOrgExpenseReportDateUpdateConfirmedAction
    >,
  ): void => {
    dispatch({
      type: SET_ORG_EXPENSE_REPORT_DATE_UPDATE_CONFIRMED,
      payload: confirmed,
    })
  }
